<template>
  <v-container class="telaAnexos">
    <div class="header-step">
      <h3>Anexos</h3>
      <p>Aqui, pode se efetuado o download dos anexos pertinentes ao processo de cotação.</p>
    </div>
    <div class="wrapper-anexos-listagem">
      <div class="content">
        <h3 class="titulo-listagem">Apólice</h3>
        <div v-if="listagemAnexosApolice.length > 0" class="content-axexos">

        </div>
        <div v-else class="listagem-vazia">
          <p>Nenhum arquivo anexado.</p>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-divider></v-divider>
      <div class="content">
        <h3 class="titulo-listagem">Proposta</h3>
        <div v-if="listagemAnexosProposta.length > 0" class="content-axexos">

        </div>
        <div v-else class="listagem-vazia">
          <p>Nenhum arquivo anexado.</p>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-divider></v-divider>
      <div class="content">
        <h3 class="titulo-listagem">Declaração de Seguro e Outros Arquivos</h3>
        <div v-if="listagemAnexosOutros.length > 0" class="content-axexos">

        </div>
        <div v-else class="listagem-vazia">
          <p>Nenhum arquivo anexado.</p>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Anexos",
  data() {
    return {
      listagemAnexosApolice: [],
      listagemAnexosProposta: [],
      listagemAnexosOutros: [],
    }
  },
}
</script>

<style>
.telaAnexos {
  margin-top:60px;
}
.telaAnexos .wrapper-anexos-listagem {
  margin-top: 40px;
}
.telaAnexos h3 {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 20px;
}
.telaAnexos .listagem-vazia {
  color: #AAAAAA;
}
.telaAnexos .content {
  margin-top: 20px;
 
}
</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/Anexos.vue